module.exports = __webpack_public_path__ + "static/media/reportcar1.00b15d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/reportcar1.png
// module id = 14
// module chunks = 0